function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchCancelPayment } from '../../../cores/api/api-dashboard';
import BarChart from '../../components/bar-chart';
import { formatTotalUser } from '../../../utils/utils';
import { OPTIONS_FILTER_CHART } from '../../../contants/option';
export default function SectionCancelPaymentChart() {
    var _a, _b;
    const _React$useState = React.useState('daily'), _React$useState2 = _slicedToArray(_React$useState, 2), period = _React$useState2[0], setPeriod = _React$useState2[1];
    const _useQuery = useQuery({
        queryKey: ['fetchCancelPayment', period],
        queryFn: () => fetchCancelPayment({
            period
        }),
        suspense: true
    }), data = _useQuery.data;
    const reasonCount = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.cancel_reason_count) !== null && _b !== void 0 ? _b : {};
    const labels = Object.keys(reasonCount);
    const values = Object.values(reasonCount);
    const barData = {
        labels,
        datasets: [{
                label: '退会率',
                data: values,
                backgroundColor: '#2563eb',
                borderRadius: 6,
                barThickness: 20
            }]
    };
    return /*#__PURE__*/ React.createElement(BarChart, {
        title: "\u30B3\u30F3\u30D0\u30FC\u30B8\u30E7\u30F3\u7387",
        userCountText: formatTotalUser({
            value: (data === null || data === void 0 ? void 0 : data.data.cancel_user_count) || 0
        }),
        options: OPTIONS_FILTER_CHART,
        data: barData,
        onPeriodChange: setPeriod
    });
}
